'use strict';

export class WebsocketsOperation {
  static Update = 'update';
  static Insert = 'insert';
  static Delete = 'delete';
}
